import { useEffect, useMemo, useCallback } from 'react'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import ReactPaginate from 'react-paginate'
import { useMain } from '../../contexts/MainContext'

import api from '../../services/api'

import { Header } from '../../components/Header'
import { ModalAdd } from '../../components/ModalAdd'
import { ModalEdit } from '../../components/ModalEdit'
import { ModalDelete } from '../../components/ModalDelete'
import { Botao } from '../../components/Botao'

import Edit from '../../assets/edit.svg'
import Checked from '../../assets/checked.svg'
import Unchecked from '../../assets/unchecked.svg'
import Trash from '../../assets/trash.svg'

import banner1 from '../../assets/banner1.png'
import banner2 from '../../assets/banner4.png'

import { Container, Title, Content, Table } from './styles'

export function HomeSlides() {
 const title = 'Página Inicial'
 const subtitle = 'Slides'

 const fields = useMemo(
  () => [
   {
    id: 'Slide',
    imagem: String,
    imagemMobile: String,
    title: String,
    link: String,
    status: Number,
    publication: String,
    expiration: String
   }
  ],
  []
 )

 const {
  slides,
  setSlides,
  modalAdd,
  toggleModalAdd,
  modalEdit,
  toggleModalEdit,
  modalDelete,
  toggleModalDelete,
  id,
  setID,
  offset,
  limit,
  handlePageClick
 } = useMain()

 const pageCount = Math.ceil(slides.length / limit)

 const loadSlides = useCallback(async () => {
  try {
   const response = await api.get('slides')

   setSlides(response.data)
  } catch (error) {
   console.log('Ocorreu um erro ao buscar os slides')
  }
 }, [setSlides])

 useEffect(() => {
  loadSlides()
 }, [loadSlides])

 return (
  <>
   <ToastContainer />

   {modalAdd && (
    <ModalAdd
     isClose={toggleModalAdd}
     isLoad={loadSlides}
     fields={fields}
     name="slides"
     title="Slide"
    />
   )}
   {modalDelete && (
    <ModalDelete
     isClose={toggleModalDelete}
     isLoad={loadSlides}
     id={id}
     name="slides"
     title="Slide"
    />
   )}
   {modalEdit && (
    <ModalEdit
     isClose={toggleModalEdit}
     isLoad={loadSlides}
     id={id}
     name="slides"
     folder="slides"
     title="Slide"
    />
   )}

   <Header title={title} subtitle={subtitle} />

   <Container>
    <Title>Gerenciador de slides</Title>
    {slides.length <= 0 ? (
     <>Nenhum slide cadastrado.</>
    ) : (
     <>
      <Table>
       <thead>
        <tr>
         <th>Exibição</th>
         <th>Slide</th>
         <th>Slide Mobile</th>
         <th>Título</th>
         <th>Link</th>
         <th>Data de Publicação</th>
         <th>Data de Expiração</th>
         <th>Status</th>
         <th colSpan="2"></th>
        </tr>
       </thead>
       <tbody>
        {slides &&
         slides.slice(offset, offset + limit).map(slide => (
          <tr key={slide.id}>
           <td>{slide.id}</td>
           <td>
            <div>
             {slide.file ? (
              <img
               src={`${process.env.REACT_APP_IMAGE_URL}/uploads/slides/${slide.file}`}
               alt={slide.title}
              />
             ) : (
              ''
             )}
            </div>
           </td>
           <td>
            <div>
             {slide.file_mobile ? (
              <img
               src={`${process.env.REACT_APP_IMAGE_URL}/uploads/slides/${slide.file_mobile}`}
               alt={slide.title}
              />
             ) : (
              ''
             )}
            </div>
           </td>
           <td>{slide.title}</td>
           <td>{slide.link}</td>
           <td>{`${slide.publication.slice(8, 10)}/${slide.publication.slice(
            5,
            7
           )}/${slide.publication.slice(0, 4)}`}</td>
           <td>{`${slide.expiration.slice(8, 10)}/${slide.expiration.slice(
            5,
            7
           )}/${slide.expiration.slice(0, 4)}`}</td>
           <td>
            {slide.status === 1 ? (
             <img src={Checked} alt="Ativo" />
            ) : (
             <img src={Unchecked} alt="Inativo" />
            )}
           </td>
           <td onMouseDown={() => setID(slide.id)}>
            <img
             src={Edit}
             alt="Editar"
             title="Editar"
             onClick={toggleModalEdit}
            />
           </td>
           <td onMouseDown={() => setID(slide.id)}>
            <img
             src={Trash}
             alt="Deletar"
             title="Deletar"
             onClick={toggleModalDelete}
            />
           </td>
          </tr>
         ))}
       </tbody>
      </Table>

      <ReactPaginate
       previousLabel={'<'}
       nextLabel={'>'}
       pageCount={pageCount}
       onPageChange={handlePageClick}
       containerClassName={'pagination'}
       previousLinkClassName={'pagination__link'}
       nextLinkClassName={'pagination__link'}
       disabledClassName={'pagination__link--disabled'}
       activeClassName={'pagination__link--active'}
      />
     </>
    )}
   </Container>

   <Container>
    <Title>Especificações dos slides</Title>
    <Content>
     <div>
      <img src={banner1} alt="Slide" />
      <h3>Slide</h3>
      <p>Formato: 1920 x 650 pixels</p>
      <p>Tamanho: Máximo 1MB</p>
     </div>
     <div>
      <img src={banner2} alt="Slide Mobile" />
      <h3>Slide Mobile</h3>
      <p>Formato: 570 x 375 pixels</p>
      <p>Tamanho: Máximo 1MB</p>
     </div>
    </Content>
   </Container>

   <Botao isOpen={toggleModalAdd} />
  </>
 )
}
